import { render, staticRenderFns } from "./BritishGas.vue?vue&type=template&id=6dc600e2"
import script from "./BritishGas.vue?vue&type=script&lang=js"
export * from "./BritishGas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../acquisition-utility-tailors/node_modules/.pnpm/vue-loader@15.11.1_@vue+com_9a5d4250dd08d9b6c6ab534d53b24d01/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports